import { render, staticRenderFns } from "./FaceRecognitionTemp.vue?vue&type=template&id=1b47badc&scoped=true&"
import script from "./FaceRecognitionTemp.vue?vue&type=script&lang=js&"
export * from "./FaceRecognitionTemp.vue?vue&type=script&lang=js&"
import style0 from "./FaceRecognitionTemp.vue?vue&type=style&index=0&id=1b47badc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b47badc",
  null
  
)

export default component.exports